import { render, staticRenderFns } from "./About.vue?vue&type=template&id=b301422e&scoped=true&lang=pug&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b301422e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b301422e')) {
      api.createRecord('b301422e', component.options)
    } else {
      api.reload('b301422e', component.options)
    }
    module.hot.accept("./About.vue?vue&type=template&id=b301422e&scoped=true&lang=pug&", function () {
      api.rerender('b301422e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/pages/About.vue"
export default component.exports